import { Component, OnDestroy, OnInit, ViewChild, inject } from "@angular/core";
import moment from "moment";
import { Moment } from "moment";
import { UntypedFormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { ActionScheduleSave, selectorSchedule } from "@app/core";
import { select, Store } from "@ngrx/store";
import { IScheduleViewer } from "@app/core/schedule/schedule-viewer.interface";
import { PlanningSegmentStore } from "@app/services/store/planning-segment-store";

@Component({
  selector: "app-base-time-navigable-page",
  templateUrl: "./base-time-navigable-page.component.html",
  styleUrls: ["./base-time-navigable-page.component.css"]
})
export class BaseTimeNavigablePageComponent implements OnInit, OnDestroy {
  planningSegmentStore = inject(PlanningSegmentStore);
  protected store = inject<Store<any>>(Store);

  public hourSelection = [
    { val: 0, display: "00:00" },
    { val: 1, display: "01:00" },
    { val: 2, display: "02:00" },
    { val: 3, display: "03:00" },
    { val: 4, display: "04:00" },
    { val: 5, display: "05:00" },
    { val: 6, display: "06:00" },
    { val: 7, display: "07:00" },
    { val: 8, display: "08:00" },
    { val: 9, display: "09:00" },
    { val: 10, display: "10:00" },
    { val: 11, display: "11:00" },
    { val: 12, display: "12:00" },
    { val: 13, display: "13:00" },
    { val: 14, display: "14:00" },
    { val: 15, display: "15:00" },
    { val: 16, display: "16:00" },
    { val: 17, display: "17:00" },
    { val: 18, display: "18:00" },
    { val: 19, display: "19:00" },
    { val: 20, display: "20:00" },
    { val: 21, display: "21:00" },
    { val: 22, display: "22:00" },
    { val: 23, display: "23:00" }
  ];

  time: number = Date.now();

  public selectedDate: Moment = moment(Date.now());
  public previousDate: Moment;
  startHour: number = 0;
  previousStartHour: number;
  public startHourField = new UntypedFormControl(this.startHour);
  numberOfHours: number = 24;
  previousNumberOfHours: number;
  public endHourField = new UntypedFormControl(0);

  public todayField = new UntypedFormControl(false);
  public mapField = new UntypedFormControl(false);

  timeFromTextValue: string;
  timeToTextValue: string;
  stateSubscription: Subscription;

  @ViewChild("scheduler", { static: true })
  protected scheduleViewer: IScheduleViewer;
  private todayMode: boolean = true;

  saveLayout() {
    const layout = this.scheduleViewer.getScheduleLayout();
    console.log("saving layout", layout, this.todayField.value);
    this.store.dispatch(
      new ActionScheduleSave({
        startHour: this.startHour,
        numberOfHours: this.numberOfHours,
        today: this.todayField.value,
        selectedDate: this.selectedDate.utc(false).toDate(),
        layout: layout,
        showMap: this.mapField.value
      })
    );
  }

  selectDate(date: Moment, save: boolean = true) {
    console.log("select event " + date);
    console.log(date);
    console.log(this.startHour);
    console.log(this.numberOfHours);
    this.previousDate = this.selectedDate;
    this.selectedDate = moment(date).utc(true);
    // this.date.setValue(this.selectedDate);
    this.startHourField.setValue(this.startHour, { emitEvent: false });
    this.endHourField.setValue((this.startHour + this.numberOfHours) % 24, {
      emitEvent: false
    });

    if (save) {
      if (!this.selectedDate.parseZone().isSame(moment().parseZone(), "day")) {
        this.todayField.setValue(false, { emitEvent: false });
      }
      this.saveLayout();
    }

    this.scheduleViewer.setDate(
      moment(this.selectedDate),
      this.startHour,
      this.numberOfHours
    );
  }

  hourFromSelected(hour: number) {
    // console.log(hour);

    // this.timeFrom.close();
    this.startHour = hour;
    let difference = this.endHourField.value - this.startHour;
    if (difference > 0) {
      this.numberOfHours = difference;
    } else {
      this.numberOfHours = difference + 24;
    }

    this.selectDate(this.selectedDate);
  }

  hourToSelected(hour: number) {
    // console.log(hour);

    // this.timeTo.close();
    this.endHourField.setValue(hour);

    let difference = hour - this.startHour;
    if (difference > 0) {
      this.numberOfHours = difference;
    } else {
      this.numberOfHours = difference + 24;
    }
    this.selectDate(this.selectedDate);
  }

  ngOnInit() {
    console.log("re-running init on resource-schedule-list");
    this.stateSubscription = this.store
      .pipe(select(selectorSchedule))
      .subscribe((schedule) => {
        console.log("loaded store");
        console.log(schedule);
        if (schedule) {
          console.log(
            "diff",
            this.selectedDate.diff(moment(schedule.selectedDate), "day")
          );
          this.todayField.setValue(schedule.today, { emitEvent: false });
          this.mapField.setValue(schedule.showMap, { emitEvent: false });

          if (
            this.previousStartHour === null ||
            schedule.startHour !== this.previousStartHour ||
            this.previousNumberOfHours === null ||
            schedule.numberOfHours !== this.previousNumberOfHours ||
            this.previousDate == null ||
            this.previousDate.diff(moment(schedule.selectedDate), "day") !== 0
          ) {
            this.previousStartHour = this.startHour;
            this.startHour = schedule.startHour;
            this.previousNumberOfHours = this.numberOfHours;
            this.numberOfHours = schedule.numberOfHours;
            this.previousDate = this.selectedDate;
            if (schedule.today) {
              this.selectedDate = moment().startOf("day");
            } else {
              this.selectedDate = moment(schedule.selectedDate)
                .utc(false)
                .startOf("day");
            }
            this.timeFromTextValue = this.startHour + ":00Z";
            this.timeToTextValue =
              ((this.startHour + this.numberOfHours) % 24) + ":00Z";
            this.selectDate(this.selectedDate, false);
            this.scheduleViewer.setDate(
              moment(this.selectedDate),
              this.startHour,
              this.numberOfHours
            );
            this.scheduleViewer.performInit();
          }
          this.scheduleViewer.applyScheduleLayout(schedule.layout);
        }
      });
    this.planningSegmentStore.loadAll(null).then((planningSegments) => {
      // console.log('planning segments');
      // console.log(planningSegments);
    });
    this.startHourField.valueChanges.subscribe((value) => {
      // console.log(value);
      this.startHour = value;
      this.selectDate(this.selectedDate);
    });
    this.endHourField.valueChanges.subscribe((value) => {
      // console.log('selected value ' + value);
      let difference = value - this.startHour;
      if (difference > 0) {
        this.numberOfHours = difference;
      } else {
        this.numberOfHours = difference + 24;
      }
      this.selectDate(this.selectedDate);
    });
    this.todayField.valueChanges.subscribe((value) => {
      console.log("today changed", value);
      this.selectDate(moment());
    });
    this.mapField.valueChanges.subscribe((value) => {
      // console.log('map changed');
      this.selectDate(moment());
    });
  }

  ngOnDestroy(): void {
    this.stateSubscription.unsubscribe();
  }
}
